import API from 'lib/API';
import { makeRoutePath } from 'lib/helpers/ServiceHelper';
import Request from 'lib/Request';
import { Guest } from 'types/Guest.type';

import { 
    CreateGuest,
    CreateGuestLog,
    CreateGuestVehicle,
    ExitGuestLog,
    FindGuest,
    FindGuestVehicle,
    ListGuestsLogs,
    ListGuestsVehicles,
    UpdateGuest
} from './contracts/Guest.contract';

const route = '/guest';

export const findGuest = (
    cpf: Guest.Model['cpf']
): Promise<FindGuest.Response> => {
    const routePath = makeRoutePath([route, cpf]);

    return Request.get(routePath);
};

export const createGuest = (
    body: CreateGuest.Body
): Promise<CreateGuest.Response> => {
    return Request.post(route, body);
};

export const updateGuest = (
    cpf: Guest.Model['cpf'],
    body: UpdateGuest.Body
): Promise<UpdateGuest.Response> => {
    const routePath = makeRoutePath([route, cpf]);

    return Request.put(routePath, body);
};

export const listGuestsLogs = (): Promise<ListGuestsLogs.Response> => {
    const routePath = makeRoutePath([route, 'log']);

    return API.get(routePath);
};

export const createGuestLog = (
    body: CreateGuestLog.Body
): Promise<CreateGuestLog.Response> => {
    const routePath = makeRoutePath([route, 'log']);

    return API.post(routePath, body);
};

export const exitGuestLog = (
    id: Guest.Log.Model['id'],
    body: ExitGuestLog.Body
): Promise<ExitGuestLog.Response> => {
    const routePath = makeRoutePath([route, 'log', id.toString(), 'exit']);

    return API.patch(routePath, body);
};

export const cancelGuestLog = (
    id: Guest.Log.Model['id']
): Promise<ExitGuestLog.Response> => {
    const routePath = makeRoutePath([route, 'log', id.toString(), 'cancel']);

    return API.patch(routePath);
};

export const listGuestsVehicles = (): Promise<ListGuestsVehicles.Response> => {
    const routePath = makeRoutePath([route, 'vehicle']);

    return API.get(routePath);
};

export const findGuestVehicle = (
    plate: Guest.Vehicle.Model['plate']
): Promise<FindGuestVehicle.Response> => {
    const routePath = makeRoutePath([route, 'vehicle', plate]);

    return API.get(routePath);
};

export const createGuestVehicle = (
    body: CreateGuestVehicle.Body
): Promise<CreateGuestVehicle.Response> => {
    const routePath = makeRoutePath([route, 'vehicle']);

    return API.post(routePath, body);
};